import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router';
import Input from "../../VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm/index";
import "./VaccinationDetailsContainer.css"
import group1 from '../../../images/group1.png';
import group2 from '../../../images/group2.png';
import UploadVaccineComponent from "../../VaccinationCertificate/UploadVaccineComponent/index";
import VaccinationDoseInfo from '../../VaccinationDoseInfo';
import useTranslation from '../../../hooks/use-translation';
import ic_date from '../../../images/ic_date.png';
import ic_dose from '../../../images/ic_dose.png';
import ic_vaccine from '../../../images/ic_vaccine.png';
import { useIsDesktop, useIsTablet } from '../../../hooks/breakpoints';
import EditVaccinationDetails from '../../EditVaccinationDetails';
import { raiseGAEventForVaccination, sendPageViewEvent } from '../../../utils/network'
import config from '../../../config.json'

const styles = {
  headerText: {
    color: '#666666',
    fontFamily: 'JioType-Bold',
    fontSize: '20px'
  },
  container: {
    paddingRight: '1em',
    height: 'max-height',
    overflowY: 'auto',
    paddingBottom: '2em'
  },
  header: {
    color: '#333333',
    fontFamily: 'JioType-Medium',
    fontSize: '22px'
  },
  images: {
    marginTop: '2em',
    marginBottom: '2em',
    display: 'flex',
    justifyContent: 'center'
  },
  mainLabel: {
    color: '#333333',
    fontFamily: 'JioType-Medium',
    fontSize: '18px'
  },
  subLabel: {
    color: '#666666',
    fontFamily: 'JioType-Medium',
    fontSize: '14px',
    marginTop: '1em'
  }
}

const getDoseLabels = {
  'dose-1': '1',
  'dose-2': '2'
}

const initialState = {
  yesButton: false,
  noButton: false,
  uploadCertButton: false,
  enterInfoButton: false,
  editButton: false,
  defaultButton: false,
  bookApptButton: false,
  handleCertError: false
}


const AlwaysScrollToBottom = ({ buttonHandler }) => {
  const elementRef = useRef();
  useEffect(() => {
    elementRef.current.scrollIntoView()
    return () => {
      window.scrollTo(0, 0)
    }
  }, [buttonHandler]);
  return <div style={{ marginTop: '7em' }} ref={elementRef} />;
};


const VaccinationDetailsContainer = ({ name, vaccinated = false, dose = '', vaccineDetails = [], vaccineOptions = [], handleFileUploading = () => { }, updateVaccineInfo, reloadData }) => {
  const { t, language } = useTranslation();
  const history = useHistory();
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();
  const urlParams = new URLSearchParams(window.location.search);
  const { name: doseName = '', dose: doseCount = '', date_of_dose = '' } = vaccineDetails[0] || []
  const [buttonHandler, setButtonHandler] = useState(initialState)

  // useEffect(() => {
  //   if (window.location.pathname === '/my-vaccinations/dose-1') {
  //     sendPageViewEvent({ VirtualPageTitle: 'my-vaccinations/dose-1' })
  //   } else {
  //     sendPageViewEvent({ VirtualPageTitle: 'my-vaccinations/dose-2' })
  //   }
  // }, [])

  const handleButtonClick = ({ type = '', disableType = 'default', action = () => { }, ga = {} }) => {
    setButtonHandler({
      ...buttonHandler,
      [`${type}Button`]: true,
      [`${disableType}Button`]: false,
      handleCertError: false
    })
    action()
    // raiseGAEventForVaccination({ ...ga, new_Category: config.gaMyVaccination });
  }

  const routeToBookAppointment = () => {
    history.push(`/book-appointment/corporate?${urlParams.toString()}`)
  }

  const isButtonClicked = (type) => buttonHandler[`${type}Button`]
  const resetButtons = () => setButtonHandler(initialState);

  if (isButtonClicked('edit')) {
    return <EditVaccinationDetails
      onSubmit={updateVaccineInfo}
      doseNo={doseCount}
      vaccines={vaccineOptions}
      vaccineName={doseName}
      vaccineDate={date_of_dose}
      resetButtons={resetButtons}
      reloadData={reloadData}
    />
  }

  const onSubmitFailure = () => {
    setButtonHandler({
      ...buttonHandler,
      handleCertError: true
    })
  }

  const renderDesktop = () => {
    return (
      <div className="express-interest-question express-interest-first-question">
        {!vaccinated &&
          <div>
            {t('HI')} {name}, {t('VACCINATED_HEADER')}
            <div className={`image-and-text margin-top-3`}>
              <div>
                <img className="group1" src={group1} alt="group1" height="221" width="187"></img>
              </div>
              <div className={`margin-left-2`}>
                <div>
                  {t('VACCINATED_Q')}{getDoseLabels[dose]}?
                </div>
                <div className={'side-align-buttons'}>
                  {<Input type="button" value={t('YES')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.yesButton ? "vaccine-details-button-clicked" : ""}`}
                    onClick={() =>
                      handleButtonClick({
                        type: 'yes',
                        disableType: 'no',
                        ga: {
                          new_Action: 'Vaccinated Yes',
                          new_Label: dose
                        }
                      })}
                  />}
                  {<Input type="button" value={t('NO')} addClassInput={`margin-left-1 update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.noButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'no', disableType: 'yes', ga: { new_Action: 'Vaccinated No', new_Label: dose } })} />}
                </div>
                {isButtonClicked('no') &&
                  <div className={'margin-top-3'}>
                    {t('PROCEED_BOOK_APPT')}
                    {<Input type="button" value={t('BOOK_APPOINTMENT')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.bookApptButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'bookAppt', action: routeToBookAppointment, ga: { new_Action: config.gaBookAppointment, new_Label: dose } })} />}
                  </div>
                }
              </div>
            </div>

            {isButtonClicked('yes') && <div className={`image-and-text margin-top-3 align-items-none`}>
              <div>
                <img className="group2" src={group2} alt="group2" height="142" width="243"></img>
              </div>
              <div className={`margin-left-2`}>
                <div>
                  {t('UPDATE_VACCINE_DETAILS_GUIDE_TEXT')}
                </div>
                <div style={{ marginTop: '1em' }}>
                  {t('PROVIDE_VACCINE_DETAILS_TEXT')}{getDoseLabels[dose]}.
                </div>
                <div className={'side-align-buttons'}>
                  {<Input type="button" value={t('UPLOAD_CERTIFICATE')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.uploadCertButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'uploadCert', disableType: 'enterInfo', ga: { new_Action: config.gaUploadCert, new_Label: dose } })} />}
                  <span className='margin-left-1'>
                    or
                  </span>
                  {<Input type="button" value={t('ENTER_VACCINE_INFO')} addClassInput={`margin-left-1 update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.enterInfoButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'enterInfo', disableType: 'uploadCert', ga: { new_Action: config.gaEnterVaccineInfo, new_Label: dose } })} />}
                </div>
                {isButtonClicked('uploadCert') && <UploadVaccineComponent _onSubmitFinish={handleFileUploading} onSubmitFailure={onSubmitFailure} noMargin />}
                {isButtonClicked('enterInfo') && <VaccinationDoseInfo onSubmit={updateVaccineInfo} doseNo={getDoseLabels[dose]} vaccines={vaccineOptions} resetButtons={resetButtons} reloadData={reloadData} />}
                <AlwaysScrollToBottom buttonHandler={buttonHandler} />
              </div>
            </div>}
          </div>
        }
        {
          vaccinated &&
          <div>
            <div>
              {t('VACCINATION_DETAILS_FOUND')}
            </div>
            <div className={'details-box'}>
              <div className={'details-box-row-1'}>
                <div>
                  <img className="ic_dose" src={ic_dose} alt="ic_dose" height="35" width="35"></img>
                  <span className="margin-left-1">{t('DOSE_LBL')}</span>
                </div>
                <div>
                  {doseCount}
                </div>
              </div>
              <div className={'details-box-row-1'}>
                <div>
                  <img className="ic_vaccine" src={ic_vaccine} alt="ic_vaccine" height="35" width="35"></img>
                  <span className="margin-left-1">{t('VACC_NAME_LBL')}</span>
                </div>
                <div>
                  {doseName}
                </div>
              </div>
              <div className={'details-box-row-1 no-border'}>
                <div>
                  <img className="ic_date" src={ic_date} alt="ic_date" height="35" width="35"></img>
                  <span className="margin-left-1">{t('DATE_LBL')}</span>
                </div>
                <div>
                  {date_of_dose}
                </div>
              </div>
            </div>
            {<Input type="button" value={t('EDIT_DETAILS_LBL')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.editButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'edit' })} />}
          </div>
        }
      </div >
    );
  }

  const renderMobile = () => {
    return (
      <div>
        {!vaccinated &&
          <div style={styles.container}>
            <div>
              <div style={styles.header}>
                {t('HI')} {name}, {t('VACCINATED_HEADER')}
              </div>
              <div style={styles.images}>
                <img className="group1" src={group1} alt="group1" height="221" width="187"></img>
              </div>
              <div style={styles.mainLabel}>{t('VACCINATED_Q')}{getDoseLabels[dose]}?</div>

              <div>
                <div className={'side-align-buttons'}>
                  {<Input type="button" value={t('YES')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.yesButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'yes', disableType: 'no', ga: { new_Action: 'Vaccinated Yes', new_Label: dose } })} />}
                  {<Input type="button" value={t('NO')} addClassInput={`margin-left-1 update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.noButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'no', disableType: 'yes', ga: { new_Action: 'Vaccinated No', new_Label: dose } })} />}
                </div>
                {isButtonClicked('no') &&
                  <div className={'margin-top-3 margin-bottom-3'}>
                    <hr />
                    <div style={styles.mainLabel}>{t('PROCEED_BOOK_APPT')}</div>
                    {<Input type="button" value={t('BOOK_APPOINTMENT')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.bookApptButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'bookAppt', action: routeToBookAppointment, ga: { new_Action: config.gaBookAppointment, new_Label: dose } })} />}
                    <AlwaysScrollToBottom buttonHandler={buttonHandler} />
                  </div>
                }
              </div>
            </div>

            {isButtonClicked('yes') && <div className={` margin-top-3 margin-bottom-3`}>
              <hr />
              <div style={styles.mainLabel}>
                {t('PROVIDE_VACCINE_DETAILS_TEXT')}{getDoseLabels[dose]}.
              </div>
              <div style={styles.subLabel}>
                {t('UPDATE_VACCINE_DETAILS_GUIDE_TEXT')}
              </div>
              <div>

                <div>
                </div>
                <div className={'side-align-buttons'}>
                  {<Input type="button" value={t('UPLOAD_CERTIFICATE')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.uploadCertButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'uploadCert', disableType: 'enterInfo', ga: { new_Action: config.gaUploadCert, new_Label: config.gaClick } })} />}
                  <span className='margin-left-1'>
                    or
                  </span>
                  {<Input type="button" value={t('ENTER_VACCINE_INFO')} addClassInput={`margin-left-1 update-vaccine-details-upload-button vaccine-details-button ${buttonHandler.enterInfoButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'enterInfo', disableType: 'uploadCert', ga: { new_Action: config.gaEnterVaccineInfo, new_Label: config.gaClick } })} />}
                </div>
                {isButtonClicked('uploadCert') && <UploadVaccineComponent _onSubmitFinish={handleFileUploading} onSubmitFailure={onSubmitFailure} noMargin />}
                {isButtonClicked('enterInfo') && <VaccinationDoseInfo onSubmit={updateVaccineInfo} doseNo={getDoseLabels[dose]} vaccines={vaccineOptions} resetButtons={resetButtons} reloadData={reloadData} />}
                <AlwaysScrollToBottom buttonHandler={buttonHandler} />
              </div>
            </div >}
          </div >
        }
        {
          vaccinated &&
          <div>
            <div style={styles.subLabel}>
              {t('VACCINATION_DETAILS_FOUND')}
            </div>
            <div className={'details-box'}>
              <div className={'details-box-row-1'}>
                <div>
                  <img className="ic_dose" src={ic_dose} alt="ic_dose" height="35" width="35"></img>
                  <span className="margin-left-1">{t('DOSE_LBL')}</span>
                </div>
                <div>
                  {doseCount}
                </div>
              </div>
              <div className={'details-box-row-1'}>
                <div>
                  <img className="ic_vaccine" src={ic_vaccine} alt="ic_vaccine" height="35" width="35"></img>
                  <span className="margin-left-1">{t('VACC_NAME_LBL')}</span>
                </div>
                <div>
                  {doseName}
                </div>
              </div>
              <div className={'details-box-row-1 no-border'}>
                <div>
                  <img className="ic_date" src={ic_date} alt="ic_date" height="35" width="35"></img>
                  <span className="margin-left-1">{t('DATE_LBL')}</span>
                </div>
                <div>
                  {date_of_dose}
                </div>
              </div>
            </div>
            {<Input type="button" value={t('EDIT_DETAILS_LBL')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button width-100 ${buttonHandler.editButton ? "vaccine-details-button-clicked" : ""}`} onClick={() => handleButtonClick({ type: 'edit' })} />}
          </div>
        }
      </div >
    )
  }
  return (
    <>{(isDesktop || isTablet) ? renderDesktop() : renderMobile()}</>
  )
}

export default VaccinationDetailsContainer;